/*
 * File: ErrorLog.ts
 * Project: mdsi-template-app
 * -----
 * Last Modified: 04 Feb 2021 11:49:46 am
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { ErrorModel } from 'models/ErrorModel';
import { ErrorInfo } from 'react';
import Rollbar from 'rollbar';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const logError = (error: ErrorModel): void => {
  const enabled = process.env.REACT_APP_ROLLBAR_ENABLED;

  const reporter = new Rollbar({
    accessToken: process.env.REACT_APP_ROLLBAR_API_KEY,
    enabled: enabled == 'true' ? true : false,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: process.env.REACT_APP_ROLLBAR_ENV,
      appVersion: process.env.REACT_APP_VERSION_NUMBER
    }
  });

  const fullErrorMessage = `${error.actionType} - ${error.status}: ${error.message}`;

  reporter.error(fullErrorMessage, error);
};

// if (error instanceof Error) {
//   const appInsights = getAppInsights();

//   if (typeof appInsights !== 'undefined') {
//     appInsights.trackException({ error, severityLevel: SeverityLevel.Error });
//   }
// }

export const logReactError = (error: Error, errorInfo: ErrorInfo): void => {
  const enabled = process.env.REACT_APP_ROLLBAR_ENABLED;
  const reporter = new Rollbar({
    accessToken: process.env.REACT_APP_ROLLBAR_API_KEY,
    enabled: enabled == 'true' ? true : false,
    captureUncaught: true,
    captureUnhandledRejections: true,
    autoInstrument: true,
    payload: {
      environment: process.env.REACT_APP_ROLLBAR_ENV,
      appVersion: process.env.REACT_APP_VERSION_NUMBER,
      ...errorInfo,
      ...error
    }
  });

  reporter.error(`${error.name}: ${error.message}`);
};
